import React from 'react';
import { connect } from 'react-redux';
import { withAdminLayout } from '../../common/admin-layout';
import { ADMIN_PAGES } from '../../assets/constants/global';
import { adminActions } from './admin-reducer';
import { BaseAdmin } from './base';
import { PROP_KEYS, ACTION_LOAD_TYPES, TEMPLATE_TYPES, ACTION_IMPORT_TYPES } from './admin-constants';

class AdminExtraPrices extends React.Component {
    componentDidMount() {
        const { loadData } = this.props;

        loadData();
    }

    render() {
        const { 
            extraPrices, extraPricesErrorMsg, handleDataPageChange, handleDataPageSizeChange,
            extraPricesPagination, isLoadedExtraPrices, importData, exportData,
            setImportedData, downloadTemplate, cleanDataErrorMsg, handleSort, extraPriceColumnTypes
        } = this.props;
        const baseProps = {
            data: extraPrices,
            isLoaded: isLoadedExtraPrices,
            errorMsg: extraPricesErrorMsg,
            handleImportData: importData,
            handleExportData: exportData,
            setImportedData: setImportedData,
            downloadTemplate: downloadTemplate,
            pagination: extraPricesPagination,
            handlePageChange: handleDataPageChange,
            handlePageSizeChange: handleDataPageSizeChange,
            cleanErrorMsg: cleanDataErrorMsg,
            sortData: handleSort,
            columnTypes: extraPriceColumnTypes
        };

        return (
            <BaseAdmin {...baseProps} />
        );
    }
}  

const mapStateToProps = (state) => {
    const { admin } = state;
    const { extraPrices, extraPricesPagination, isLoadedExtraPrices, extraPricesErrorMsg, extraPriceColumnTypes } = admin;

    return {
        extraPrices, isLoadedExtraPrices, extraPricesPagination, extraPricesErrorMsg, extraPriceColumnTypes
    };
}

const { action, isLoadedKey, paginationKey, dataKey, importAction, importedKey, errorMsgKey, fileKey, columnTypesKey } = {
    action: ACTION_LOAD_TYPES.extraPrice,
    isLoadedKey: PROP_KEYS.isLoadedExtraPrices,
    paginationKey: PROP_KEYS.extraPricesPagination,
    dataKey: PROP_KEYS.extraPrices,
    importAction: ACTION_IMPORT_TYPES.extraPrice,
    importedKey: PROP_KEYS.importedExtraPrices,
    errorMsgKey: PROP_KEYS.extraPricesErrorMsg,
    fileKey: TEMPLATE_TYPES.ExtraPrice,
    columnTypesKey: PROP_KEYS.extraPriceColumnTypes
}

const mapDispatchToProps = {
    loadData: () => adminActions.load({ 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    importData: () => adminActions.importData({
        importAction, action, isLoadedKey, importedKey, errorMsgKey, paginationKey, dataKey
    }),
    exportData: () => adminActions.exportData({ 
        action, isLoadedKey, fileKey
    }),
    setImportedData: (file) => adminActions.setValue(importedKey, file),
    cleanDataErrorMsg: () => adminActions.setValue(errorMsgKey, []),
    downloadTemplate: () => adminActions.downloadTemplate({
        isLoadedKey, fileKey
    }),
    handleDataPageChange: (page, pageSize) => adminActions.handlePaginationChange(page, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleDataPageSizeChange: (_page, pageSize) => adminActions.handlePaginationChange(1, pageSize, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    }),
    handleSort: (_pagination, _filters, sorter) => adminActions.handleSort(1, sorter, { 
        action, isLoadedKey, paginationKey, dataKey, fileKey, columnTypesKey
    })
}

const connectedAdminExtraPrices = connect(mapStateToProps, mapDispatchToProps)(withAdminLayout(AdminExtraPrices, ADMIN_PAGES.AdminExtraPrices));
export { connectedAdminExtraPrices as AdminExtraPrices };